import React, { useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { Notifier } from '@softwaredev_cegeka/stix-notifier'

import Main from './routes/Main'
import withAuth from 'src/components/auth/withAuth'
import Unauthorized from './routes/Unauthorized'

class App extends React.Component {
    render() {
        const MainContent = withAuth(Main)

        //redirect task-view urls to the new task-center in horizon until the entire workflows is moved
        const TaskViewRedirect = () => {
            useEffect(() => {
                window.location.href = 'https://horizon.cegeka.com/task-center'
            }, [])

            return null
        }

        return (
            <Router>
                <Switch>
                    <Route
                        exact
                        path={'/unauthorized'}
                        component={Unauthorized}
                    />
                    <Route path={'/task-view*'} component={TaskViewRedirect} />
                    <Notifier>
                        <MainContent />
                    </Notifier>
                </Switch>
            </Router>
        )
    }
}

export default App
